import Backbone from 'backbone'
import template from './historical.hbs'
import Table from './historical-table'
import Graph, {canDisplay} from './historical-graph'
import _ from 'lodash'
import conductor from 'scoreboard/components/conductor'
import autofocus from 'scoreboard/polyfills/autofocus'
import permissions from 'scoreboard/components/permissions'
import spectator from 'scoreboard/components/spectator'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import guard from 'scoreboard/components/unsaved/guard'
import layoutManager from 'scoreboard/components/layout-manager'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'

const chartContainerHeight = 335 // Matches height of the container set in historical.scss

var Historical = Backbone.View.extend({

	// this.model is an Initiative
	className: 'panel',

	hasGraph: function() {
		return canDisplay(this.model)
	},

	/**
	 * @param {String} options.mode 'table' or 'graph'
	 * @param {Boolean} [options.legend=true]
	 * @param {InitiativeOverviewHeader} options.header
	 */
	initialize: function(options={}) {
		this.options = _.extend({legend:true}, options)
		this.on('resize', (heightAndWidth ={}) => {
			if (_.isUndefined(this._graph)) {
				return
			}
			const {height, width} = heightAndWidth
			this._graph.resize({
				width: width || this.$('.panel-content').width(),
				height: height || chartContainerHeight
			})
		})
	},

	render: function() {
		var mode
		if (this.$el.children().length === 0) {
			mode = this.options.mode || 'graph'
		} else {
			mode = Backbone.history.location.pathname.indexOf('/table') === -1
				? 'graph' : 'table'
		}

		this.$el.empty().append(template(this.context()))
		this.$('.add-status').click(this.addStatus.bind(this))

		if (this.hasGraph()) {
			this._toggle = new LabeledToggle({
				value: mode,
				options: [{
					value: 'graph',
					label: 'common.graph'
				}, {
					value: 'table',
					label: 'initiatives.tableView' + (this.model.statusType() === 'own' ? '' : '.calculated')
				}]
			})

			this.$('.add-status').before(this._toggle.el)
			this._toggle.render()

			this._toggle._onClick = function(e) {
				guard.conditionallyRun(() => LabeledToggle.prototype._onClick.call(this._toggle, e))
			}.bind(this)
			this._toggle.delegateEvents()

			this.listenTo(this._toggle, 'change', this.toggle.bind(this))

			// actually display the graph or table
			this.toggle()

			this.$('.panel-header').addClass('panel-header-large has-labeled-toggle')
		} else {
			// If there's no graph, then we don't need the toggle. Don't mess with the URL,
			// though (silent: true)
			this.table({silent: true})
		}


		this.secure()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		// https://github.com/SpiderStrategies/Scoreboard/issues/28519
		this.delegateEvents()

		return this
	},

	context: function () {
		return _.extend(this.model.toJSON(), {
			ownStatuses: this.model.statusType() === 'own'
		})
	},

	secure: function() {
		if (!permissions.updateInitiativeStatus(this.model.get('organizationId')) || !permissions.isEditableIfReplicated(this.model)) {
			this.$('.add-status').remove()
		}
	},

	toggle: function () {
		if (this._toggle.val() === 'graph') {
			this.graph()
		} else {
			this.table()
		}
		this.trigger('resize') // #23312 Toggling will change page height since the table/graph will be different heights, make
								// sure the graph is sized correctly. e.g. scrollbars could have been added if the page increased in substance
								// which means the graph width will be slightly narrower
		/*
		 * When an initiative is switched from 'graph' <-> 'table' mode the toggler
		 * url needs to be updated to match so the user can bookmark table or graph,
		 * but not while being spectated
		 */
		!spectator.getCurrent() && _.invoke(this.options.header, 'renderBookmarkToggler')
	},

	graph: function() {
		this._removeTable()

		if (!spectator.getCurrent() && !layoutManager.export) {
			conductor.navigate('initiatives/' + this.model.id)
		}
		this.$('.add-status').removeClass('is-not-displayed')

		let panelContent = this.$('.panel-content')
		this._graph = new Graph({
			model: this.model,
			width: panelContent.width(),
			height: chartContainerHeight,
			legend: this.options.legend
		})
		panelContent.empty().append(this._graph.el)
		this._graph.render()

		this.$el.removeClass('panel-with-table')
	},

	table: function(opt) {
		opt = opt || {}

		this._removeGraph()

		if (!spectator.getCurrent() && !opt.silent) {
			conductor.navigate('initiatives/' + this.model.id + '/table')
		}
		this.$('.add-status').addClass('is-not-displayed')

		this._table = new Table({ model: this.model })
		this.$('.panel-content').empty().append(this._table.el)
		this._table.render()
		this.$el.addClass('panel-with-table')
	},

	addStatus: function() {
		// setting the toggle to table will also render the table view (if necessary)
		this._toggle.val('table', { silent: false })
		this._table.addStatus()
		autofocus(this._table.el)
	},

	removeTooltips: function() {
		_.invoke(this._table, 'removeTooltips')
	},

	_removeTable: function () {
		this._table && this._table.remove()
		delete this._table
	},

	_removeGraph: function () {
		this._graph && this._graph.remove()
		delete this._graph
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)

		_.invokeMap([this._table, this._graph, this._toggle, this.covertButtonTooltips], 'remove')
	}

})

export default Historical

Historical.__filename__ = 'initiatives/overview/historical.js'
